import { useMutation, useQuery } from '@tanstack/react-query';

import { isAxiosError } from 'axios';

import { ArticleActionStatusApiResponse } from '../apis';

import { clientAxios } from '@/shared/api';
import { ApiResponse } from '@/shared/types';

interface ArticleActionProps {
  like?: string;
  isLiked: boolean;
  comment?: string;
  isScrapped: boolean;
}

export const useArticleActionStatus = (newsId: number): ArticleActionProps => {
  const defaultData = {
    like: undefined,
    isLiked: false,
    comment: undefined,
    isScrapped: false,
  };

  const { data, isLoading, isError } = useQuery({
    queryKey: ['articleActionStatusApi', newsId],
    queryFn: async () => {
      const { data } = await clientAxios.get<
        ApiResponse<ArticleActionStatusApiResponse>
      >(`articleActionStatusApi/`, {
        params: { newsId },
      });

      const { like_count, is_like, comment_count, is_scrapped } = data.data;

      return {
        like: like_count?.toString() || '0',
        isLiked: is_like || false,
        comment: comment_count?.toString() || '0',
        isScrapped: is_scrapped || false,
      };
    },
  });

  if (isLoading || isError) {
    return defaultData;
  }

  return data || defaultData;
};

export const usePostArticleLikeApi = () => {
  return useMutation({
    mutationFn: async (newsId: number) => {
      try {
        const { data } = await clientAxios.post(`/postArticleLikeApi/`, {
          newsId,
        });

        return data;
      } catch (error) {
        if (isAxiosError(error) && error.response) {
          if (error.response.data.error.status === 401) {
            throw new Error('Unauthorized');
          } else {
            throw new Error('Internal Server Error');
          }
        }
      }
    },
  });
};
